import React, { Component } from 'react'
import { View, Text } from 'react-native'
import { connect } from "react-redux";

import { ProgressBar } from '.';
import Button from './form/Button';
import { SuccessAvatar } from './Image';
import styles from '../styles';
import { currentStrangth } from '../action';
import localize from '../localize';

class TaskSuccess extends Component {

    componentDidMount() {
        if (this.props.familyStrenght.length <= 0)
            this.props.currentStrangth()
    }

    render() {
        const { title, buttonPress, point, component, familyStrenght } = this.props;
        let progress = familyStrenght.strength ? familyStrenght.strength / 10 : 0
        return (
            <View style={{ paddingVertical: 20, paddingHorizontal: 20 }}>
                <View style={{ flexDirection: 'column', alignItems: 'center' }}>
                    <View style={{ alignItems: 'center', marginVertical: 20 }}>
                        <SuccessAvatar size={84} />
                        <Text style={[styles.containDesc, styles.cD, { textAlign: "center", marginTop: 30 }]}>{title}</Text>
                    </View>
                    <Text style={[styles.containDesc, styles.cD, { textAlign: "center", marginTop: 20, fontSize: 16 }]}>{point}</Text>
                </View>
                <ProgressBar
                    progress={progress}
                    start={familyStrenght.maxLevel}
                    end={familyStrenght.minLevel}
                />
                {
                    component ? component :
                        <View style={{ marginTop: 80, marginHorizontal: 35 }}>
                            <Button
                                title={localize.Done}
                                size="small"
                                onPress={buttonPress}
                            />
                        </View>
                }

            </View>
        )
    }

}

const mapStateToProps = ({ setting }) => {
    return {
        familyStrenght: setting.familyStrenght,

    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        currentStrangth: () => dispatch(currentStrangth()),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(TaskSuccess);